import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleModal } from "../../../reducers/modalReducer";
import { showMessage } from "../../../config";

const ModuleCardHeader = ({ resolvedLogo, logoAlt, subTitle, moduleTagColor, name, moduleSlug, company, subscriptionLabel, setTab, isPaid, hasPurchased, isRestricted, onRequirePurchase, onRestrictedClick, externalUrl, isResearchAid, isNavigationModule, isDirectorsModule, tempDirectorsModuleSlug, isMemberPermissionRestricted, isInvestmentReadiness, isExitReadiness, needToCreate, onNeedToCreate, isCreatingIRM, isResearchAidReportGenerated, onOpenResearchAidReport, module, report, setTabName }) => {
    const dispatch = useDispatch();
    const tagHex = typeof moduleTagColor === 'string' ? moduleTagColor.trim() : '';
    const hasValidTagHex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(tagHex);
    return (
        <div className='df aic jcsb w100'>
            <div className='df aic w100' style={{ overflow: 'hidden' }}>
                <div
                    className='br10px bg1 p0-5rem df aic jcc'
                    style={{ width: '60px', height: '60px', border: '1px solid #E3E3E3', flexShrink: 0 }}
                >
                    <img src={resolvedLogo} alt={logoAlt} width={52} height={47} />
                </div>
                <div className='df fdc pr w100'>
                    {subTitle
                        ? <p
                            className={`fs12px fw400 pa ${hasValidTagHex ? '' : 'c15 op70'}`}
                            style={{
                                left: '1rem',
                                top: '-14px',
                                ...(hasValidTagHex ? { color: tagHex } : {})
                            }}
                        >{subTitle.length > 22 ? subTitle.substring(0, 22) + '...' : subTitle}</p>
                        : null
                    }
                    <div className='df aic jcsb w100'>
                        {isMemberPermissionRestricted
                            ? <div className='ml1rem df fdc cp' style={{ overflow: 'hidden' }} onClick={() => showMessage("You don't have permission for this module. Please contact your admin to gain access.")}>
                                <span className='fs15px fw500 c15' style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', lineHeight: '1.2' }}>
                                    {name === 'InvestorMatch' ? <>Investor<span className="c4">Match</span></> : name.length > 30 ? name.substring(0, 30) + '...' : name}
                                </span>
                            </div>
                            : <>
                                <Link
                                    to={(isResearchAidReportGenerated && isNavigationModule && isResearchAid) ? `/company/${company?.['_id']}#${report['_id']}?${report['reportType']}-researchaid` : ((isPaid && !hasPurchased) || ((isInvestmentReadiness || isExitReadiness) && needToCreate)) ? '#' : isRestricted ? '#' : isDirectorsModule ? '#' : (isNavigationModule && isResearchAid && externalUrl === '#') ? '' : (isNavigationModule && isResearchAid) ? `/researchAid/${company?.['_id']}?${externalUrl}` : (externalUrl ? '#' : `#${moduleSlug}`)}
                                    state={{ company }}
                                    onClick={(e) => {
                                        if (isResearchAidReportGenerated && isNavigationModule && isResearchAid) {
                                            onOpenResearchAidReport && onOpenResearchAidReport();
                                            return;
                                        }
                                        if ((isInvestmentReadiness || isExitReadiness) && needToCreate) {
                                            e.preventDefault();
                                            if (!isCreatingIRM) onNeedToCreate && onNeedToCreate();
                                            return;
                                        }
                                        if (isRestricted) {
                                            e.preventDefault();
                                            onRestrictedClick && onRestrictedClick();
                                            return;
                                        }
                                        if (isDirectorsModule && hasPurchased) {
                                            e.preventDefault();
                                            dispatch(toggleModal({ open: 'showTempDirectors', tempDirectorsModuleSlug: tempDirectorsModuleSlug || moduleSlug }));
                                            return;
                                        }
                                        if (externalUrl && !isResearchAid) {
                                            e.preventDefault();
                                            window.open(externalUrl, '_blank', 'noopener,noreferrer');
                                            return;
                                        }
                                        if (isPaid && !hasPurchased) {
                                            e.preventDefault();
                                            onRequirePurchase && onRequirePurchase();
                                            return;
                                        }
                                        if (isNavigationModule && isResearchAid && externalUrl === '#') {
                                            e.preventDefault();
                                            dispatch(toggleModal({ open: 'swotReportPopup' }));
                                            return;
                                        }
                                        setTab(moduleSlug);
                                    }}
                                    className='fs15px fw500 c15 ml1rem'
                                    style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', marginTop: '0px', lineHeight: '1.2' }}
                                >
                                    {name === "InvestorMatch" ? <>Investor<span className="c4">Match</span></> : name.length > 30 ? name.substring(0, 30) + '...' : name}
                                </Link>
                                {subscriptionLabel
                                    ? <span className='fs14px fw600 ml0-5rem c7' style={{ flexShrink: 0, letterSpacing: '0.03em' }}>
                                        {(company?.['subscription'] === "Free" || company?.['subscription'] === "Lite") ? (/(audit|repository)/i.test(name) ? 'LITE' : 'PRO') : 'PRO'}
                                    </span>
                                    : name?.includes('KPI Report')
                                        ? <span className='fs14px fw600 ml0-5rem ttu c59' style={{ flexShrink: 0, letterSpacing: '0.03em' }}>Free</span>
                                        : null
                                }
                            </>
                        }
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ModuleCardHeader;
